import { Box, HStack, Skeleton, SkeletonCircle, SkeletonText, VStack } from '@chakra-ui/react';
import { FC, Fragment } from 'react';

export interface IMessageLoaderProps {
  size: number;
}

export const MessageLoader: FC<IMessageLoaderProps> = ({ size }) => {
  return (
    <Fragment>
      {Array.from({ length: size }, (_, i) => (
        <Box h="122px" w="full" key={i} mb={4}>
          <HStack w="full" alignItems="flex-start">
            <SkeletonCircle size="5" />
            <VStack w="full" alignItems="flex-start">
              <HStack mb={2} w="full" alignItems="center">
                <SkeletonText w="full" mt={1} noOfLines={1} />
                <Skeleton w="25px" h="8px" />
              </HStack>
              <SkeletonText w="full" noOfLines={4} />
              <HStack>
                <Skeleton w="25px" h="15px" />
                <Skeleton w="25px" h="15px" />
              </HStack>
            </VStack>
          </HStack>
        </Box>
      ))}
    </Fragment>
  );
};
